module.exports = __webpack_public_path__ + "static/media/btn-fr.5951eb5f.png";